exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".poll-games .answer-img {\n  width: 200px;\n  margin: 40px auto 0;\n  border-radius: 20px;\n  display: block;\n}\n.poll-games .footer-slogan {\n  margin: 24px auto 0;\n  display: block;\n  height: 48px;\n}\n.poll-games .appstore {\n  margin-top: -20px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/stylus-loader!./node_modules/vue-loader/lib??vue-loader-options!./src/components/common/PollGames.vue?vue&type=style&index=0&id=12a097e4&lang=stylus
// module id = 363
// module chunks = 3